import { Component, OnInit } from '@angular/core';
import { AchatService } from '../../../../../../services/achat/achat.service';

@Component({
    selector: 'app-tous-retour-frns',
    templateUrl: './tous-retour-frns.component.html',
    styleUrls: ['./tous-retour-frns.component.scss']
})
export class TousRetourFrnsComponent implements OnInit {
    constructor(private achatService: AchatService) {}

    ngOnInit(): void {
        this.achatService.filterRetourFournisseurByStatus('Tous');
    }
}
